<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addClassModal"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة فصل جديد
            </button>

            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addClassModal"
              tabindex="-1"
              aria-labelledby="addClassModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة فصل</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form @submit.prevent="addNewClass($event)">
                      <div class="row">
                        <!-- className -->
                        <div class="col-12">
                          <div class="form-group">
                            <label for="className">اسم الفصل</label>
                            <input
                              type="text"
                              id="className"
                              class="form-control"
                              placeholder="اسم الفصل"
                              v-model="newClass.title"
                              required
                            />
                          </div>
                        </div>
                        <!-- Class Description -->
                        <div class="col-12">
                          <div class="form-group">
                            <label for="classDescription">وصف الفصل</label>
                            <textarea
                              id="classDescription"
                              cols="30"
                              rows="5"
                              class="form-control"
                              placeholder="وصف الفصل"
                              v-model="newClass.description"
                            ></textarea>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="form-group">
                            <label for="">اضافة الفصل ضمن مجموعة</label>
                            <v-select
                              class="form-select form-control mt-2"
                              v-model="newClass.groupsFullInfo"
                              multiple
                              v-if="this.groups.length > 0"
                              :options="groups"
                              label="group_name"
                            />
                            <div class="text-center" v-else>
                              لا يوجد مجموعات حتى الان
                            </div>
                          </div>
                        </div>

                        <!-- Buttons -->
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button type="submit" class="btn add w-100">
                              أضافة
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Modal End -->

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table v-show="this.classes.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th class="fit" scope="col">الرقم</th>
                  <th scope="col">اسم الفصل</th>
                  <th scope="col">وصف الفصل</th>
                  <th scope="col">عدد الطلاب</th>
                  <th scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(classRow, index) in this.classes" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ classRow.title }}</td>
                  <td>{{ classRow.description }}</td>
                  <td>{{ classRow.students_count }}</td>
                  <td>
                    <div class="control">
                      <router-link
                        :to="{
                          name: 'StudentsOfClass',
                          params: { id: classRow.class_id },
                        }"
                        class="btn students"
                        v-if="hasPermission('students')"
                      >
                        <img
                          class="img-invert ms-2"
                          src="@/assets/login-icon/users-solid.svg"
                          alt="Students"
                        />
                        الطلاب
                      </router-link>
                      <button
                        class="btn me-2 edit"
                        data-bs-toggle="modal"
                        data-bs-target="#EditClasssModal"
                        @click="this.getSelectClass(classRow.class_id)"
                      >
                        <i class="fas fa-edit ms-2"></i>
                        تعديل
                      </button>
                      <div
                        class="modal fade"
                        tabindex="-1"
                        id="EditClasssModal"
                        aria-labelledby="EditClasssModalLabel"
                        data-bs-backdrop="static"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-body text-end">
                              <div class="text-start">
                                <button
                                  type="button"
                                  class="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <form @submit.prevent="updateSelectClass($event)">
                                <div class="row">
                                  <!-- className -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="className">اسم الفصل</label>
                                      <input
                                        type="text"
                                        id="className"
                                        class="form-control"
                                        placeholder="اسم الفصل"
                                        v-model="updatedClass.title"
                                        required
                                      />
                                    </div>
                                  </div>
                                  <!-- Class Description -->
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for="classDescription"
                                        >وصف الفصل</label
                                      >
                                      <textarea
                                        id="classDescription"
                                        cols="30"
                                        rows="5"
                                        class="form-control"
                                        placeholder="وصف الفصل"
                                        v-model="updatedClass.description"
                                      ></textarea>
                                    </div>
                                  </div>

                                  <div class="col-12">
                                    <div class="form-group">
                                      <label for=""
                                        >اضافة الفصل ضمن مجموعة</label
                                      >
                                      <v-select
                                        class="form-select form-control mt-2"
                                        v-model="updatedClass.groupsFullInfo"
                                        multiple
                                        v-if="this.groups.length > 0"
                                        :options="groups"
                                        label="group_name"
                                      />
                                      <div class="text-center" v-else>
                                        لا يوجد مجموعات حتى الان
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Buttons -->
                                  <div class="col-12">
                                    <div class="form-group text-start mt-4">
                                      <button
                                        data-bs-dismiss="modal"
                                        class="btn w-100 edit"
                                      >
                                        تعديل
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        class="btn me-2 delete"
                        @click="deleteSelectedClass(classRow.class_id)"
                      >
                        <i class="fas fa-trash-alt ms-2"></i>
                        حذف
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.classes) || this.classes.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد فصول حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";

export default {
  data() {
    return {
      // Loading
      isloading: false,
      // Groups
      groups: [],
      // Current Page Name
      currentView: "الفصول",
      classes: [],
      updatedClass: {
        groups: [],
      },
      newClass: {
        title: "",
        description: "",
        students_count: 0,
        groups: [],
        groupsFullInfo: [],
      },
      // Search
      searchValue: "",
    };
  },
  methods: {
    ...mapActions("classesModule", [
      "addClassFromClasses",
      "getClassById",
      "updateClass",
      "deleteClass",
    ]),
    ...mapActions("groupsModule", ["fetchGroups"]),

    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.classes.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.classes.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------

    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.classes = this.getClasses.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------

    // Basic Button In Table
    // Add Class
    async addNewClass(event) {
      this.onSelectGroupsToAdd();
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      await this.addClassFromClasses(this.newClass);
      closeButton.click();
      this.clearAndShowSuccess("تم الإضافة بنجاح");
    },
    // Delete Class
    deleteSelectedClass(id) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الفصل؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم الحذف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteClass(id);
        }
      });
    },

    // Get Class By Id
    async getSelectClass(id) {
      await this.getClassById(id);
      this.updatedClass = this.getUpdateClass;
    },

    // Update Class
    updateSelectClass(event) {
      this.onSelectGroupsToUpdate();

      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.updateClass(this.updatedClass);
      closeButton.click();
      this.clearAndShowSuccess("تم التعديل بنجاح");
    },

    // Default Functions
    // Clear Input and Messages me Success
    clearAndShowSuccess(message) {
      this.successAdd(message);
      this.clearData();
    },
    // Toast Seccuss Message
    successAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Clear Data
    clearData() {
      this.newClass = {
        title: "",
        description: "",
        students_count: 0,
      };
    },

    async getAllGroups() {
      this.groups = await this.fetchGroups();
    },
    onSelectGroupsToAdd() {
      this.newClass.groups = [];
      this.newClass.groupsFullInfo.forEach((id) => {
        this.newClass.groups.push(id.group_id);
      });
    },
    onSelectGroupsToUpdate() {
      if (this.updatedClass.groups.length > 0) {
        this.updatedClass.groups = [];
        this.updatedClass.groupsFullInfo.forEach((id) => {
          this.updatedClass.groups.push(id.group_id);
        });
      }
    },
  },
  async created() {
    if (this.isGroupFirstLoad) await this.getAllGroups();
    console.log(this.groups);
  },

  computed: {
    ...mapGetters("classesModule", [
      "getClasses",
      "getUpdateClass",
      "isLoading",
      "isFirstLoad",
    ]),
    ...mapGetters("groupsModule", ["getGroups", "isGroupFirstLoad"]),
  },
  mounted() {
    this.classes = this.getClasses;
    this.groups = this.getGroups;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
  },
  watch: {
    getClasses() {
      this.classes = this.getClasses;
    },
    getGroups() {
      this.groups = this.getGroups;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    isGroupFirstLoad() {
      this.groupFirstLoad = this.isGroupFirstLoad;
    },
  },
};
</script>

<style></style>
